/**
 * Sprint 5-a-hotfix-1 · PlanCompletionBanner · 完成後詢問繼續 **inline banner**（非 modal）。
 * 原 PlanCompletionDialog 為 modal overlay（擋住 Excel）→ 改 chat panel 內 inline·non-blocking。
 */
import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface Props {
  totalTokens: number;
  totalCost: number;
  onNewRequest: () => void;
  onFinish: () => void;
}

const PlanCompletionBanner: React.FC<Props> = ({ totalTokens, totalCost, onNewRequest, onFinish }) => {
  const { t } = useTranslation();
  const tt = (k: string, d: string) => t(`agentic.${k}`, d);
  return (
    <Box sx={{
      mt: 1, p: 1.5, borderRadius: 1,
      border: '1px solid', borderColor: 'success.main', bgcolor: '#f6fff6',
    }}>
      <Typography variant="subtitle2" gutterBottom>🎉 {tt('completeTitle', '計畫已完成')}</Typography>
      <Typography variant="caption" color="text.secondary" sx={{ mb: 1, display: 'block' }}>
        {tt('completeTotal', '本次總計')}:{' '}
        <strong>{totalTokens.toLocaleString()}</strong> tokens · <strong>${totalCost.toFixed(4)}</strong>
        {' · '}{tt('completeAsk', '還需要我做別的嗎？')}
      </Typography>
      <Stack direction="row" spacing={1}>
        <Button variant="contained" size="small" onClick={onNewRequest}>{tt('newRequest', '提新需求')}</Button>
        <Button variant="text" size="small" onClick={onFinish}>{tt('finishConversation', '結束對話')}</Button>
      </Stack>
    </Box>
  );
};

export default PlanCompletionBanner;
